import Message from './message';
import MessageBox from './message-box';
import MessageText from './message-text';
import MessageRich from './message-rich';
import MessageItems from './message-items';
import MessageFile from './message-file';
import MessagePhotoCard from './message-photo-card';
import MessageMiniProgramCard from './message-mini-program-card';
import MessageSound from './message-sound';
import MessageEvent from './message-event';
import MessageBase from './message-base';
import MessageInfo from './message-info';
import MessageRemind from './message-remind';
import MessageVideo from './message-video';

Message.MessageText = MessageText;
Message.MessageItems = MessageItems;
Message.MessageRich = MessageRich;
Message.MessageFile = MessageFile;
Message.MessagePhotoCard = MessagePhotoCard;
Message.MessageMiniProgramCard = MessageMiniProgramCard;
Message.MessageSound = MessageSound;
Message.MessageBox = MessageBox;
Message.MessageEvent = MessageEvent;
Message.MessageBase = MessageBase;
Message.MessageInfo = MessageInfo;
Message.MessageRemind = MessageRemind;
Message.MessageVideo = MessageVideo;

export default Message;
